/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningspayoutrunning2Inputs */

const en_earningspayoutrunning2 = /** @type {(inputs: Earningspayoutrunning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Being paid out`)
};

const de_earningspayoutrunning2 = /** @type {(inputs: Earningspayoutrunning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gerade ausgezahlt`)
};

/**
* | output |
* | --- |
* | "Being paid out" |
*
* @param {Earningspayoutrunning2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningspayoutrunning2 = /** @type {((inputs?: Earningspayoutrunning2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningspayoutrunning2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningspayoutrunning2(inputs)
	return de_earningspayoutrunning2(inputs)
});
export { earningspayoutrunning2 as "earningsPayoutRunning" }